'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import Cart from './components/Cart.vue';
import CartRow from './components/CartRow.vue';
import CartRowCharge from './components/CartRowCharge.vue';

var _class = function _class() {
    _classCallCheck(this, _class);

    // Register component globaly
    Vue.component('cart', Cart);
    Vue.component('cart-row', CartRow);
    Vue.component('cart-row-charge', CartRowCharge);
};

export default _class;


//////////////////
// WEBPACK FOOTER
// ./resources/templates/semperit/assets/js/modules/checkout/components/cart/index.js
// module id = null
// module chunks = 